/**
 * Re-derive the page from scratch.
 *
 * A one-line wrapper so callers have something a test can observe. jsdom defines
 * `location.reload` as non-writable and non-configurable, and `window.location` itself as
 * non-configurable, so the reload cannot be spied or stubbed in place — which is why the
 * cross-tab `reload` branch went untested until this existed.
 */
export const reloadPage = (): void => window.location.reload()
